 
import { registerView } from '../viewRegistry';
import { DopeTextRenderer } from '../renderer/bitmapFont';
import { getCanonicalSafeArea } from '../safeArea';
import { CRT_PROFILES } from '../crt/crtProfiles.js';
import { generateAsciiArt, ensureFigletFont } from '../../utils/asciiArt';

const SPLASH_MESSAGE = 'LOADING...';
// No ASCII-art: render with bitmap font for crisper result and faster load.
// --------------------------------------------------------------

function renderWidgetSplash(ctx, t, w, h, params = {}) {
  // Use the full canvas size so the artwork fills the image completely.
  const bw = w;
  const bh = h;

  // Clear the canvas with black
  ctx.fillStyle = '#000000';
  ctx.fillRect(0, 0, bw, bh);
  
  // Signal readiness ASAP so build script waits correctly even if font still loading.
  if (typeof window !== 'undefined' && !window.DCW_SPLASH_READY) {
    window.DCW_SPLASH_READY = true; // will be re-set later but idempotent
  }

  // Ensure bitmap font ready; if not, delay rendering
  if (!DopeTextRenderer.isReady()) {
    ctx.fillStyle = '#39FF14';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = 'bold 20px monospace';
    ctx.fillText('Loading...', bw / 2, bh / 2);
    return;
  }

  // --- Determine dynamic scale so the text fills as much space as possible ---
  // Measure once at scale 1 to get intrinsic dimensions
  const baseMetrics = DopeTextRenderer.measureDOSText(SPLASH_MESSAGE, 1);

  const maxWidth = bw;        // Use entire canvas width
  const maxHeight = bh * 0.9; // Leave small vertical breathing space

  // Compute candidate scales that would exactly fit width / height
  const scaleForWidth = maxWidth / baseMetrics.width;
  const scaleForHeight = maxHeight / baseMetrics.height;

  // Choose the smaller to ensure the text stays inside both bounds
  let textScale = Math.min(scaleForWidth, scaleForHeight);

  // Slight padding to avoid clipping glow (3%)
  textScale *= 0.69;

  // Glow effect
  ctx.fillStyle = '#39FF14';
  ctx.shadowColor = '#39FF14';
  ctx.shadowBlur = 8;

  const finalMetrics = DopeTextRenderer.measureDOSText(SPLASH_MESSAGE, textScale);
  const startX = (bw - finalMetrics.width) / 2;
  const startY = (bh - finalMetrics.height) / 2;

  DopeTextRenderer.renderDOSText(ctx, SPLASH_MESSAGE, startX, startY, textScale);

  ctx.shadowBlur = 0;
  
  // Signal completion for build scripts (only once)
  if (typeof window !== 'undefined' && !window.DCW_WIDGET_READY) {
    window.DCW_SPLASH_READY = true;
    // Also set the generic widget ready flag expected by build scripts
    window.DCW_WIDGET_READY = true;
    console.log('[WIDGET_SPLASH] Splash rendered successfully');
  }
}

registerView('widget_splash', renderWidgetSplash); 